<template>
  <section class="sub-page iframe">
    <!-- herosection -->
    <div class="relative mt-20 mb-20">
      <img src="/theme-assets/images/dashboardImg.png" alt="" class="h-[260px] w-full">
      <div class="absolute md:top-[100px] top-20 left-[15%] md:left-[25%] right-[15%] md:right-[25%] text-center">
        <div class=" py-10 px-10 md:px-20 bg-[#262637]">
          <p class="text-[#1cfa78] text-3xl">
            Market Directory
          </p>
          <p class="text-[#8c8c92]">
            Get easy access to housing market professionals & institutions based on their functions
          </p>
          <form class="" @submit.prevent="calculateMortgage">
            <div class="flex md:gap-8 mt-8 md:flex-row flex-col  gap-1">
              <select id="states" v-model="form.state" name="states" class="w-full rounded-sm p-2 md:w-[50%]">
                <option v-for="(state, i) in states" :key="i" :value="state">
                  {{ state.stateName }}
                </option>
              </select>

              <button class="bg-[#1cfa78] text-[#262637] px-4 rounded-sm" @click="filterByState()">
                Search
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Why People Choose us -->
    <div v-if="agents.length == 0" class="md:w-[70%] mx-auto w-[90%] mt-36">
      <p class="pb-4 text-lg">
        We are still loading developers for {{ form?.state?.stateName }} State<br>
        Please check again later.
      </p>
    </div>
    <div v-if="agents.length > 0" class="md:w-[70%] mx-auto w-[90%] mt-36">
      <div v-for="(agent, i) in agents" :key="i" class="flex items-start mb-10 w-full gap-4 md:w-[40%]">
        <div>
          <img src="/theme-assets/images/housing.png" alt="" class="w-[91px] h-[71px] object-cover">
        </div>
        <div>
          <p class="pb-4 text-lg">
            {{ agent.agent }}
          </p>
          <p class="text-xs">
            <i class="ti-location-pin" />
            {{ agent.address }}
          </p>
          <p class="text-xs">
            Tel: {{ agent.tel1 }}, {{ agent.tel2 }}
          </p>
        </div>
      </div>
    </div>

    <div class="md:w-[70%] mx-auto w-[90%] mt-36">
      <p class="text-center w-full md:w-[70%] text-2xl mx-auto">
        People choose us because <br> we serve the best for
      </p>

      <div class="flex flex-column items-center my-10 flex-col flex-wrap justify-between  md:flex-row">
        <div class="flex items-start mb-10 w-full gap-4 md:w-[40%]">
          <div>
            <img src="/theme-assets/images/agent.png" alt="" class="w-[91px] h-[71px] object-cover">
          </div>
          <div>
            <p class="pb-4 text-lg">
              Agents/brokers/realtors
            </p>
            <p class="text-xs">
              With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
            </p>
          </div>
        </div>
        <div class="flex items-start mb-10 w-full gap-4 md:w-[40%]">
          <div>
            <img src="/theme-assets/images/housing.png" alt="" class="w-[91px] h-[71px] object-cover">
          </div>
          <div>
            <p class="pb-4 text-lg">
              Housing Developers
            </p>
            <p class="text-xs">
              With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
            </p>
          </div>
        </div>
        <div class="flex items-start mb-10 w-full gap-4 md:w-[40%]">
          <div>
            <img src="/theme-assets/images/legalAdviser.png" alt="" class="w-[91px] h-[71px] object-cover">
          </div>
          <div>
            <p class="pb-4 text-lg">
              Legal Advisors
            </p>
            <p class="text-xs">
              With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
            </p>
          </div>
        </div>
        <div class="flex items-start mb-10 w-full gap-4 md:w-[40%]">
          <div>
            <img src="/theme-assets/images/legalAdviser.png" alt="" class="w-[91px] h-[71px] object-cover">
          </div>
          <div>
            <p class="pb-4 text-lg">
              Mortgage Providers
            </p>
            <p class="text-xs">
              With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
            </p>
          </div>
        </div>
        <div class="flex items-start mb-10 w-full gap-4 md:w-[40%]">
          <div>
            <img src="/theme-assets/images/regulatoryBodies.png" alt="" class="w-[91px] h-[71px] object-cover">
          </div>
          <div>
            <p class="pb-4 text-lg">
              RegulatoryBodies
            </p>
            <p class="text-xs">
              With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
            </p>
          </div>
        </div>
        <div class="flex items-start mb-10 w-full gap-4 md:w-[40%]">
          <div>
            <img src="/theme-assets/images/surveyor.png" alt="" class="w-[91px] h-[71px] object-cover">
          </div>
          <div>
            <p class="pb-4 text-lg">
              Surveyors
            </p>
            <p class="text-xs">
              With lots of unique blocks, you can easily build a page without coding. Build your next landing page.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Form from 'vform';
import states from './states.json';
import agents from './agents.json';

export default {
  name: 'HousingMarket',
  components: {},

  data: () => ({
    nav_title: 'Housing Market Directory',
    navs: [
      {
        route_name: 'housing.market',
        route_title: 'Housing Market Directory',
      }
    ],
    visible: true,
    iframe: {
      src: 'https://app.powerbi.com/view?r=eyJrIjoiNWVhNTM4OTItNGMwNS00MjIwLWI5ZWUtYWQ4MzQxNmMwNTAyIiwidCI6ImE4MTNjYTk4LWU0MTMtNDJkMS1iNzNmLTlmZGM3YTJhYjhkNCIsImMiOjh9',
      loaded: false
    },
    states: states,
    agents: agents,
    form: new Form({
      state: ''
    })
  }),

  methods: {
    load() {
      this.iframe.loaded = true;
    },
    filterByState() {
      let selectedState = this.form.state.stateName
      this.agents = this.agents.filter(x => x.state == selectedState);
      
    }
  },
}
</script>
<style scoped>
.iframe {
  overflow-y: hidden;
}
</style>

